import {
  useGlobalStateSelector,
  words,
  stateKeysToSetAddress,
  stateKeysToSetUserName,
} from './globalState';
import { TextLine3 } from './UtilComponents';
import {
  SelectAddressFromKeypoolSection,
  SelectWalletBox,
  SignIcon,
} from './KeysAndSigningUI';
import {
  handleClickRegisterInitial,
  handleClickRegisterInitialFromWif,
  handleClickRegisterAdditional,
  handleClickRegisterAdditionalFromWif,
} from './KeyBox';
import { checkRequiredItemsForSetup, handleClickSetup } from './userRegistration';
import { handleClickLogin } from './login';
import { useNfcrwScan } from './nativeAppHooks';
import { NativeAppReadButton } from './NativeAppUI';
import {
  walletsAvailable,
  decryptByKeyCardStyle,
  keepKeyPairsInMemory,
  keepKeyPairsAndSubAddressesInMemory,
  getSecretsFromNfc,
  getSecretsFromKeyCardRecords,
  getSecretsFromQr,
  getParentAddressFromSubAddress,
} from './keysAndSigning';
import {
  readNfc,
  decodeNdefRecord,
} from './utils';
import iconCheck from './image/check_24dp_FILL0_wght400_GRAD0_opsz24.svg';
import iconQr from './image/qr_code_2_FILL0_wght400_GRAD0_opsz24.svg';
import iconKeyCard from './image/playing_cards_FILL0_wght400_GRAD0_opsz24.svg';
import iconEdit from './image/edit_FILL0_wght400_GRAD0_opsz48.svg';
import termsAndConditionsExhibitorHtml from './tac_exhibitor.static.link';
import termsAndConditionsPurchaserHtml from './tac_purchaser.static.link';
import termsAndConditionsOwnerHtml from './tac_owner.static.link';
import privacyPolicyHtml from './privacypolicy.static.link';
// import sctHtml from './static/sct.static.html';

// USER REGISTRATION POPUP ; type: 'userRegistrationPopup'
function UserRegistrationPopup(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const popupLayer = props.popupLayer;
  const mode = state.popup[popupLayer].mode;

  return <UserRegistration popupLayer={popupLayer} mode={mode} />;
}

// ACCEPTANCE OF TEMS AND CONDITIONS
function AcceptanceOfTermsAndConditions(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const popupLayer = props.popupLayer;

  if (state.configure.acceptedVersionOfTheTermsAndConditions !== state.config.clientParameters.versionOfTheTermsAndConditions ||
      state.configure.acceptedVersionOfPrivacyPolicy !== state.config.clientParameters.versionOfPrivacyPolicy) {
    return (
      <button className='flexColumn justifyContentCenter alignItemsCenter borderNone backgroundColorWhite heightMin3 textLeft focusEffect01 colorRed cursor borderRadius2 riseOut2 marginTopBottom0p5' tabindex='0'
        onClick={ () => {
            dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'acceptedVersionOfTheTermsAndConditions'], value: state.config.clientParameters.versionOfTheTermsAndConditions });
            dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'acceptedVersionOfPrivacyPolicy'], value: state.config.clientParameters.versionOfPrivacyPolicy });
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } }); 
        }
      }>
        <div>
          {words.iAcceptTheTermsAndConditionsAndPrivacypolicy[state.language]}
        </div>
      </button>
    );
  }
  else {
    return (
      <button className='borderNone backgroundColorWhite heightMin3 textLeft focusEffect01 borderRadius2 riseOut2 marginTopBottom0p5'
        onClick={ () => {
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } }); 
        }
      }>
          {words.theTermsAndConditionsAndPrivacypolicyHaveBeenAccepted[state.language]}
      </button>
    );
  }
}


// TERMS AND CONDITIONS POPUP ; type: 'termsAndConditionsPopup'
function TermsAndConditionsPopup(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const popupLayer = props.popupLayer;
  const target = state.popup[popupLayer]?.body?.target;

  const termsAndConditions = {
    exhibitor: {
      face: words.termsAndConditionsForExhibitor[state.language],
      html: termsAndConditionsExhibitorHtml,
    },
    purchaser: {
      face: words.termsAndConditionsForPurchaser[state.language],
      html: termsAndConditionsPurchaserHtml,
    },
    owner: {
      face: words.termsAndConditionsForOwner[state.language],
      html: termsAndConditionsOwnerHtml,
    },
    privacyPolicy: {
      face: words.privacyPolicy[state.language],
      html: privacyPolicyHtml,
    },
  };

  const buttons = ['exhibitor', 'purchaser', 'owner', 'privacyPolicy'].filter( target1 => target1 !== target ).map( target2 =>
    <button className='backgroundColorMonacottoPale borderMonacotto margin0p5'
      onClick={ () => {
        const popup = { type: 'termsAndConditionsPopup', body: { target: target2 } };
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: popup });
      }}
    >
      { termsAndConditions[target2].face }
    </button>
  );

  return (
    <div>
      <div>
        { buttons }
      </div>
      <AcceptanceOfTermsAndConditions popupLayer={popupLayer} />
      <div dangerouslySetInnerHTML={ { __html: termsAndConditions[target]?.html } } />
      <AcceptanceOfTermsAndConditions popupLayer={popupLayer} />
    </div>
  );
}

// SCT POPUP
// eslint-disable-next-line no-unused-vars
function SCTPopup(props) {
  return (
    null
    // <div dangerouslySetInnerHTML={ { __html: sctHtml } } />
  );
}

// USER REGISTRATION
function UserRegistration(props) {
  const clientParameters = useGlobalStateSelector( ({ state }) => state.config.clientParameters );
  const keyPairsInPoolAll = useGlobalStateSelector( ({ state }) => state.keyPairs );
  const assetInfos = useGlobalStateSelector( ({ state }) => state.assetInfo );
  const monacards = useGlobalStateSelector( ({ state }) => state.monacard );
  const language = useGlobalStateSelector( ({ state }) => state.language || 'english' );
  const paths = useGlobalStateSelector( ({ state }) => state.configKB.clientParameters.paths );
  const walletType = useGlobalStateSelector( ({ state }) => state.walletType );
  const configure = useGlobalStateSelector( ({ state }) => state.configure );
  const login = useGlobalStateSelector( ({ state }) => state.login );
  const session = useGlobalStateSelector( ({ state }) => state.session );
  const marginOfSessionTime = useGlobalStateSelector( ({ state }) => state.marginOfSessionTime );
  const usersGeneralIndex = useGlobalStateSelector( ({ state }) => state.usersGeneralIndex );
  const device = useGlobalStateSelector( ({ state }) => state.device );
  const passkey = useGlobalStateSelector( ({ state }) => state.passkey );
  const subAddresses = useGlobalStateSelector( ({ state }) => state.subAddresses );
  const network = useGlobalStateSelector( ({ state }) => state.networkMona );
  const active = useGlobalStateSelector( ({ state }) => state.active );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const cookies = useGlobalStateSelector( ({ cookies }) => cookies );
  const setCookie = useGlobalStateSelector( ({ setCookie }) => setCookie );
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  const pass = clientParameters.specialMessage;

  // iPhone アプリでキーカードを読み、利用登録してログインする（登録ボタンはアプリ起動用の Universal Link になる）
  const nfcrwScan = useNfcrwScan({
    enabled: walletType === 'nfcNative',
    language,
    onRecords: async ({ records }) => {
      try {
        const { mnemonic, keyPairs, addressMain } = await getSecretsFromKeyCardRecords({ dispatch, pass, records, language, network });

        const setupResponse = await handleClickSetup({
          dispatch,
          cookies,
          setCookie,
          keyPairs,
          keyPairsInPoolAll,
          session,
          assetInfos,
          monacards,
          configure,
          walletType,
          network,
          clientParameters,
          marginOfSessionTime,
          language,
          active,
        });

        const sessionToOverride = {
          [addressMain]: {
            sessionId: setupResponse.body.sessionId[addressMain],
            expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
          },
        };

        handleClickLogin({
          dispatch,
          popupLayer,
          keyPairs,
          keyPairsInPoolAll,
          sessionToOverride,
          login,
          walletType,
          session,
          marginOfSessionTime,
          assetInfos,
          monacards,
          network,
          usersGeneralIndex,
          clientParameters,
          language,
        })
        .then( response => {
          dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: response.activeAddress });
        });

        const mnemonicRecords = [{ mnemonic, address: addressMain }];
        keepKeyPairsAndSubAddressesInMemory({ dispatch, mnemonicRecords, paths, periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs, language, network });
      }
      catch {
        return;
      }
    },
    onFailure: () => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToReadNfc[language] });
    },
  });

  // const mode = props.mode;
  let registrationSection;

  // アドレスセクション・スイッチアイコン

  let addressSection;

  if (walletType === 'keypool') {
    addressSection =
    <SelectAddressFromKeypoolSection
      stateKeys={['configure', 'addressMain']}
      stateKeysToSetAddress={stateKeysToSetAddress}
      stateKeysToSetUserName={stateKeysToSetUserName}
      loginEnabled={false}
      setConfigure={true}
      subAddressEnabled={true}
      popupLayer={popupLayer}
    />;
  }

  // ユーザー名セクション

  const userNameSection =
  <div className='flexRow justifyContentFlexStart alignItemsCenter '>
    <TextLine3 fieldName='userName' keys={['configure', 'userName']} face={words.userName[language]} tooltip='right' />
  </div>

  // TAC文言

  let tacWord;

  if (configure.acceptedVersionOfTheTermsAndConditions === clientParameters.versionOfTheTermsAndConditions &&
      configure.acceptedVersionOfPrivacyPolicy === clientParameters.versionOfPrivacyPolicy) {
    tacWord = words.theTermsAndConditionsAndPrivacypolicyHaveBeenAccepted[language];
  }
  else {
    tacWord = words.termsAndConditionsAndPrivacypolicy[language];
  }

  // 利用規約ボタン

  const tacButton =
  <button
    className={
      'borderNone backgroundColorWhite heightMin3 textLeft focusEffect01 cursor borderRadius2 riseOut2 marginTopBottom0p5' +
      (configure.readTheTermsAndConditions ? '' : 'colorRed')
    }
    tabindex='0'
    onClick={ () => {
      const popup = {
        type: 'termsAndConditionsPopup',
        body: { target: 'exhibitor' },
      };

      dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
      dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'readTheTermsAndConditions'], value: true });
      dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'readPrivacyPolicy'], value: true });
    }}
  >
    { tacWord }
  </button>;

  // 利用規約同意チェックボックス

  let check;
  let checkboxColor;

  if (
    configure.acceptedVersionOfTheTermsAndConditions === clientParameters.versionOfTheTermsAndConditions &&
    configure.acceptedVersionOfPrivacyPolicy === clientParameters.versionOfPrivacyPolicy
  ) {
    check = <img className='size1x1' src={iconCheck} alt='check' />;
    checkboxColor = 'backgroundColorPinkPale';
  }
  else {
    checkboxColor = 'backgroundColorTransparent';
  }

  const tacCheckbox =
  <button
    className={ 'width1p2 height1p2 borderMonacottoNoRadius padding0 marginSide1 ' + checkboxColor }
    onClick={ () => {
      if (!configure.acceptedVersionOfTheTermsAndConditions || !configure.acceptedVersionOfPrivacyPolicy) {
        dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'acceptedVersionOfTheTermsAndConditions'], value: clientParameters.versionOfTheTermsAndConditions });
        dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'acceptedVersionOfPrivacyPolicy'], value: clientParameters.versionOfPrivacyPolicy });
      }
      else {
        dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'acceptedVersionOfTheTermsAndConditions'], value: null });
        dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'acceptedVersionOfPrivacyPolicy'], value: null });
      }
    }}  
  >
    { check }
  </button>;

  // 登録ボタン

  let registrationButton;
  let mnemonicImportButtonColor = '';
  let wifImportButtonColor = '';

  if (typeof configure.mnemonic === 'string' && configure.mnemonic !== '') {
    mnemonicImportButtonColor = ' backgroundColorPinkPale';
  }

  if (typeof configure.wif === 'string' && configure.wif !== '') {
    wifImportButtonColor = ' backgroundColorPinkPale';
  }

  const webauthnRegistrationButton =
  <>
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      disabled={ passkey.busy }
      onClick={ async () => {
        try {
          dispatch({ type: 'setStateMultiLayers', keys: ['passkey', 'busy'], value: true });

          const wifIsSet = typeof configure.wif === 'string' && configure.wif !== '';
          let registrationResult;

          if (wifIsSet) {
            registrationResult = await handleClickRegisterInitialFromWif({
              dispatch,
              wif: configure.wif,
              configure,
              network,
              language,
            });
          }
          else {
            registrationResult = await handleClickRegisterInitial({
              dispatch,
              mnemonic: configure.mnemonic,
              configure,
              network,
              language,
            });
          }

          const { mnemonic, keyPairs, address: addressMain } = registrationResult;

          const setupResponse = await handleClickSetup({
            dispatch,
            cookies,
            setCookie,
            keyPairs,
            keyPairsInPoolAll,
            session,
            assetInfos,
            monacards,
            configure,
            walletType,
            network,
            clientParameters,
            marginOfSessionTime,
            language,
            active,
          });

          const sessionToOverride = {
            [addressMain]: {
              sessionId: setupResponse.body.sessionId[addressMain],
              expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
            },
          };

          handleClickLogin({
            dispatch,
            popupLayer,
            keyPairs,
            keyPairsInPoolAll,
            sessionToOverride,
            login,
            walletType,
            session,
            marginOfSessionTime,
            assetInfos,
            monacards,
            network,
            usersGeneralIndex,
            clientParameters,
            language,
          })
          .then( response => {
            if (wifIsSet) {
              // WIFは階層鍵ではないため親アドレスを持たない
              dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: null });
            }
            else {
              dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: response.activeAddress });
            }
          });

          if (wifIsSet) {
            // WIFは単一鍵のため、ニーモニック由来のサブアドレス展開は行わない
            keepKeyPairsInMemory({
              dispatch,
              keyPairs,
              periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs,
              language,
              network,
            });

            dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'wif'], value: '' });
          }
          else {
            const popup = { type: 'confirmMnemonicPopup', body: { mnemonic } };
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });

            const mnemonicRecords = [{ mnemonic, address: addressMain }];
            keepKeyPairsAndSubAddressesInMemory({ dispatch, mnemonicRecords, paths, periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs, language, network });
          }
        }
        finally {
          dispatch({ type: 'setStateMultiLayers', keys: ['passkey', 'busy'], value: false });
        }
      }}
    >
      <div>
        {words.initialRegistration[language]}
      </div>
      <SignIcon />
    </button>
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      disabled={ passkey.busy }
      onClick={ async () => {
        try {
          dispatch({ type: 'setStateMultiLayers', keys: ['passkey', 'busy'], value: true });

          const wifIsSet = typeof configure.wif === 'string' && configure.wif !== '';
          let registrationResult;

          if (wifIsSet) {
            registrationResult = await handleClickRegisterAdditionalFromWif({
              dispatch,
              wif: configure.wif,
              configure,
              network,
              language,
            });
          }
          else {
            registrationResult = await handleClickRegisterAdditional({
              dispatch,
              mnemonic: configure.mnemonic,
              configure,
              network,
              language,
            });
          }

          const { mnemonic, keyPairs, address: addressMain } = registrationResult;

          const setupResponse = await handleClickSetup({
            dispatch,
            cookies,
            setCookie,
            keyPairs,
            keyPairsInPoolAll,
            session,
            assetInfos,
            monacards,
            configure,
            walletType,
            network,
            clientParameters,
            marginOfSessionTime,
            language,
            active,
          });

          const sessionToOverride = {
            [addressMain]: {
              sessionId: setupResponse.body.sessionId[addressMain],
              expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
            },
          };

          handleClickLogin({
            dispatch,
            popupLayer,
            keyPairs,
            keyPairsInPoolAll,
            sessionToOverride,
            login,
            walletType,
            session,
            marginOfSessionTime,
            assetInfos,
            monacards,
            network,
            usersGeneralIndex,
            clientParameters,
            language,
          })
          .then( response => {
            if (wifIsSet) {
              // WIFは階層鍵ではないため親アドレスを持たない
              dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: null });
            }
            else {
              dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: response.activeAddress });
            }
          });

          if (wifIsSet) {
            // WIFは単一鍵のため、ニーモニック由来のサブアドレス展開は行わない
            keepKeyPairsInMemory({
              dispatch,
              keyPairs,
              periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs,
              language,
              network,
            });

            dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'wif'], value: '' });
          }
          else {
            const popup = { type: 'confirmMnemonicPopup', body: { mnemonic } };
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });

            const mnemonicRecords = [{ mnemonic, address: addressMain }];
            keepKeyPairsAndSubAddressesInMemory({ dispatch, mnemonicRecords, paths, periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs, language, network });
          }
        }
        finally {
          dispatch({ type: 'setStateMultiLayers', keys: ['passkey', 'busy'], value: false });
        }
      }}
    >
      <div>
        {words.additionalRegistration[language]}
      </div>
      <SignIcon />
    </button>
    <button className={'buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' + mnemonicImportButtonColor} tabindex='0'
      onClick={ () => {
        const popup = {
          type: 'readMnemonicForRegistrationPopup',
        }

        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
      }}
    >
      { words.importMnemonic[language] }
    </button>
    <button className={'buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' + wifImportButtonColor} tabindex='0'
      onClick={ () => {
        const popup = {
          type: 'readWifForRegistrationPopup',
        }

        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
      }}
    >
      { words.importWif[language] }
    </button>
  </>;

  if (walletType === 'keybox') {
    registrationButton =
    <div className='flexColumn alignItemsCenter'>
      { webauthnRegistrationButton }
    </div>;
  }
  else if (walletType === 'nfc') {
    registrationButton =
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      onClick={ async () => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[language] });
        const { mnemonic, keyPairs, addressMain } = await getSecretsFromNfc({ dispatch, pass, language, network });

        const setupResponse = await handleClickSetup({
          dispatch,
          cookies,
          setCookie,
          keyPairs,
          keyPairsInPoolAll,
          session,
          assetInfos,
          monacards,
          configure,
          walletType,
          network,
          clientParameters,
          marginOfSessionTime,
          language,
          active,
        });

        const sessionToOverride = {
          [addressMain]: {
            sessionId: setupResponse.body.sessionId[addressMain],
            expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
          },
        };

        handleClickLogin({
          dispatch,
          popupLayer,
          keyPairs,
          keyPairsInPoolAll,
          sessionToOverride,
          login,
          walletType,
          session,
          marginOfSessionTime,
          assetInfos,
          monacards,
          network,
          usersGeneralIndex,
          clientParameters,
          language,
        })
        .then( response => {
          dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: response.activeAddress });
        });

        const mnemonicRecords = [{ mnemonic, address: addressMain }];
        keepKeyPairsAndSubAddressesInMemory({ dispatch, mnemonicRecords, paths, periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs, language, network });
      }}
    >
      <div>
        {words.serviceAccessRegistration[language]}
      </div>
      <SignIcon />
    </button>;
  }
  else if (walletType === 'nfcNative') {
    registrationButton =
    <NativeAppReadButton
      nfcrwScan={nfcrwScan}
      intent='keycard'
      marginTop={false}
      // 名前や同意が欠けたままアプリへ出ない（戻ってから言われないように、先に確かめる）
      canStart={ () => checkRequiredItemsForSetup({ dispatch, configure, language }) }
      face={
        <>
          <div>
            {words.serviceAccessRegistration[language]}
          </div>
          <SignIcon />
        </>
      }
    />;
  }
  else if (walletType === 'qr') {
    registrationButton =
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      onClick={ async () => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[language] });
        let secrets;

        try {
          secrets = await getSecretsFromQr({ dispatch, pass, popupLayer, language, network });
        }
        catch {
          // 読み取りのポップアップを閉じたとき（popupClosed）や、読み取り・復号できなかったとき（通知済み）は、ここで終わる
          return;
        }

        const { mnemonic, keyPairs, addressMain } = secrets;

        const setupResponse = await handleClickSetup({
          dispatch,
          cookies,
          setCookie,
          keyPairs,
          keyPairsInPoolAll,
          session,
          assetInfos,
          monacards,
          configure,
          walletType,
          network,
          clientParameters,
          marginOfSessionTime,
          language,
          active,
        });

        const sessionToOverride = {
          [addressMain]: {
            sessionId: setupResponse.body.sessionId[addressMain],
            expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
          },
        };

        handleClickLogin({
          dispatch,
          popupLayer,
          keyPairs,
          keyPairsInPoolAll,
          sessionToOverride,
          login,
          walletType,
          session,
          marginOfSessionTime,
          assetInfos,
          monacards,
          network,
          usersGeneralIndex,
          clientParameters,
          language,
        })
        .then( response => {
          dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: response.activeAddress });
        });

        const mnemonicRecords = [{ mnemonic, address: addressMain }];
        keepKeyPairsAndSubAddressesInMemory({ dispatch, mnemonicRecords, paths, periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs, language, network });
      }}
    >
      <div>
        {words.serviceAccessRegistration[language]}
      </div>
      <SignIcon />
    </button>;
  }
  else if (walletType === 'keypool') {
    registrationButton =
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      onClick={ async () => {
        const addressMain = configure.addressMain;
        if (addressMain === undefined || addressMain === null || addressMain === '') {
          dispatch({ type: 'setNotification', key: 'notification', value: words.selectAnAddressFromTheKeypool[language] });
          throw new Error('addressMain is not selected');
        }

        const setupResponse = await handleClickSetup({
          dispatch,
          cookies,
          setCookie,
          keyPairs: undefined,
          keyPairsInPoolAll,
          session,
          assetInfos,
          monacards,
          configure,
          walletType,
          network,
          clientParameters,
          marginOfSessionTime,
          language,
          active,
        });

        const sessionToOverride = {
          [addressMain]: {
            sessionId: setupResponse.body.sessionId[addressMain],
            expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
          },
        };

        handleClickLogin({
          dispatch,
          popupLayer,
          keyPairs: null,
          keyPairsInPoolAll,
          sessionToOverride,
          activeAddressCandidate: addressMain,
          login,
          walletType,
          session,
          marginOfSessionTime,
          assetInfos,
          monacards,
          network,
          usersGeneralIndex,
          clientParameters,
          language,
        })
        .then( (loginResponse) => {
          const parentAddress = getParentAddressFromSubAddress({ subAddresses, subAddress: loginResponse?.activeAddress });
          dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: parentAddress });
        });
      }}
    >
      <div>
        {words.serviceAccessRegistration[language]}
      </div>
      <SignIcon />
    </button>;
  }
  else if (walletType === 'mpurse') {
    registrationButton =
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      onClick={ async () => {
        const setupResponse = await handleClickSetup({
          dispatch,
          cookies,
          setCookie,
          keyPairs: undefined,
          keyPairsInPoolAll,
          session,
          assetInfos,
          monacards,
          configure,
          walletType,
          network,
          clientParameters,
          marginOfSessionTime,
          language,
          active,
        });

        const addressMain = Object.keys(setupResponse.body.sessionId)[0];
        const sessionToOverride = {
          [addressMain]: {
            sessionId: setupResponse.body.sessionId[addressMain],
            expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
          },
        };

        handleClickLogin({
          dispatch,
          popupLayer,
          keyPairs: null,
          keyPairsInPoolAll,
          sessionToOverride,
          login,
          walletType,
          session,
          marginOfSessionTime,
          assetInfos,
          monacards,
          network,
          usersGeneralIndex,
          clientParameters,
          language,
        })
        .then( response => {
          // keyPair を渡してないので、ログイン時に、他のアドレスに active を上書きされる可能性があるので、さらに上書く。
          dispatch({ type: 'setStateMultiLayers', keys: ['active', 'addressMain'], value: addressMain });
        });
      }}
    >
      <div>
        {words.serviceAccessRegistration[language]}
      </div>
      <SignIcon />
    </button>;
  }
  else {
    registrationButton =
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      onClick={ async () => {
        if (walletType === undefined || walletType === null) {
          const walletType = walletsAvailable({ hasCamera: device?.hasCamera })[0];
          dispatch({ type: 'setState', key: 'walletType', value: walletType });
        }

        const result = await handleClickSetup({
          dispatch,
          cookies,
          setCookie,
          keyPairs: undefined,
          keyPairsInPoolAll,
          session,
          assetInfos,
          monacards,
          configure,
          walletType,
          network,
          clientParameters,
          marginOfSessionTime,
          language,
          active,
        });

        if (result?.message === 'nfcRequired') {
          const { mnemonic, keyPairs, addressMain } = await getSecretsFromNfc({ dispatch, pass, language, network });

          const setupResponse = await handleClickSetup({
            dispatch,
            cookies,
            setCookie,
            keyPairs,
            keyPairsInPoolAll,
            session,
            assetInfos,
            monacards,
            configure,
            walletType,
            network,
            clientParameters,
            marginOfSessionTime,
            language,
            active,
          });

          const sessionToOverride = {
            [addressMain]: {
              sessionId: setupResponse.body.sessionId[addressMain],
              expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
            },
          };

          handleClickLogin({
            dispatch,
            popupLayer,
            keyPairs,
            keyPairsInPoolAll,
            sessionToOverride,
            login,
            walletType,
            session,
            marginOfSessionTime,
            assetInfos,
            monacards,
            network,
            usersGeneralIndex,
            clientParameters,
            language,
          })
          .then( response => {
            dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: response.activeAddress });
          });

          const mnemonicRecords = [{ mnemonic, address: addressMain }];
          keepKeyPairsAndSubAddressesInMemory({ dispatch, mnemonicRecords, paths, periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs, language, network });
        }
        else if (result?.message === 'bcRequired') {
          let secrets;

          try {
            secrets = await getSecretsFromQr({ dispatch, pass, popupLayer, language, network });
          }
          catch {
            // 読み取りのポップアップを閉じたとき（popupClosed）や、読み取り・復号できなかったとき（通知済み）は、ここで終わる
            return;
          }

          const { mnemonic, keyPairs, addressMain } = secrets;

          const setupResponse = await handleClickSetup({
            dispatch,
            cookies,
            setCookie,
            keyPairs,
            keyPairsInPoolAll,
            session,
            assetInfos,
            monacards,
            configure,
            walletType,
            network,
            clientParameters,
            marginOfSessionTime,
            language,
            active,
          });

          const sessionToOverride = {
            [addressMain]: {
              sessionId: setupResponse.body.sessionId[addressMain],
              expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
            },
          };

          handleClickLogin({
            dispatch,
            popupLayer,
            keyPairs,
            keyPairsInPoolAll,
            sessionToOverride,
            login,
            walletType,
            session,
            marginOfSessionTime,
            assetInfos,
            monacards,
            network,
            usersGeneralIndex,
            clientParameters,
            language,
          })
          .then( response => {
            dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: response.activeAddress });
          });

          const mnemonicRecords = [{ mnemonic, address: addressMain }];
          keepKeyPairsAndSubAddressesInMemory({ dispatch, mnemonicRecords, paths, periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs, language, network });
        }
      }}
    >
      <div>
        {words.serviceAccessRegistration[language]}
      </div>
      <SignIcon />
    </button>;
  }

  // 登録セクション

  registrationSection =
  <div>
    <div className="visibleMiddleOrMore flexColumn alignItemsCenter borderKOM marginTop1 padding1">
      <div className=''>
        { words.userRegistration[language] }
      </div>
      <SelectWalletBox keypoolButtonVisible={true} />
      <div className='marginTop0p5 '>
        { addressSection }
      </div>
      <SelectMakeMyHomeOrNot />
      <div className='marginTop1 '>
        { userNameSection }
      </div>
      <div className='flexRow justifyContentFlexStart alignItemsCenter marginTopBottom0p5 '>
        { tacCheckbox }
        { tacButton }
      </div>
      { registrationButton }
    </div>
    <div className="visibleSmallOrLess flexColumn alignItemsCenter borderKOM marginTop1 padding1">
      <div className=''>
        { words.userRegistration[language] }
      </div>
      <SelectWalletBox keypoolButtonVisible={true} />
      <div className='marginTop0p5 '>
        { addressSection }
      </div>
      <SelectMakeMyHomeOrNot />
      <div className='marginTop1 '>
        { userNameSection }
      </div>
      <div className='flexRow justifyContentFlexStart alignItemsCenter marginTopBottom0p5 '>
        { tacCheckbox }
        { tacButton }
      </div>
      { registrationButton }
    </div>
  </div>;


  return registrationSection;
}

// READ MNEMONIC FOR REGISTRATION POPUP ; type: 'readMnemonicForRegistrationPopup'
function ReadMnemonicForRegistrationPopup(props) {
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  const configure = useGlobalStateSelector( ({ state }) => state.configure );
  const hasCamera = useGlobalStateSelector( ({ state }) => state.device?.hasCamera );
  const pass = useGlobalStateSelector( ({ state }) => state.config.clientParameters.specialMessage );
  const language = useGlobalStateSelector( ({ state }) => state.language );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const nativeAppAvailable = walletsAvailable({ hasCamera }).includes('nfcNative');

  // iPhone アプリで読み込む: キーカード形式は 2 件目を復号、プレーンは 1 件目をそのまま
  const nfcrwScan = useNfcrwScan({
    enabled: nativeAppAvailable,
    language,
    // records は Web NFC の形（Web NFC の読み込みボタンと同じ読み方をする）
    onRecords: async ({ records, intent }) => {
      let mnemonic;

      if (intent === 'keycard') {
        const recordNo = 1;
        const record = records?.[recordNo];

        const encryptedMnemonic = decodeNdefRecord({ dispatch, record, language });
        mnemonic = await decryptByKeyCardStyle({ pass, dispatch, encrypted: encryptedMnemonic, language });
      }
      else if (intent === 'plain') {
        const recordNo = 0;
        const record = records?.[recordNo];

        mnemonic = decodeNdefRecord({ dispatch, record, language });
      }
      else {
        dispatch({ type: 'setNotification', key: 'notification', value: words.failedToReadNfc[language] });
        throw new Error(`unknown intent: ${intent}`);
      }

      dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'mnemonic'], value: mnemonic });
      dispatch({ type: 'setNotification', key: 'notification', value: words.readingDone[language] });
    },
    onFailure: () => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToReadNfc[language] });
    },
  });

  let readButtons = [];

  const nfcButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.readKeyCardNfcMnemonic[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[language] });
          const records = await new Promise( (resolve, reject) => {
            readNfc({ dispatch, resolve, reject, language });
          });

          const recordNo = 1;
          const record = records?.[recordNo];

          const encryptedMnemonic = decodeNdefRecord({ dispatch, record, language });
          const mnemonic = await decryptByKeyCardStyle({ pass, dispatch, encrypted: encryptedMnemonic, language });
          dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'mnemonic'], value: mnemonic });
          dispatch({ type: 'setNotification', key: 'notification', value: words.readingDone[language] });
        }}
      >
        <div>
          { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </button>
    </>;

  const nfcPlainButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.readNfcPlainTextMnemonic[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithNfcTag[language] });
          const records = await new Promise( (resolve, reject) => {
            readNfc({ dispatch, resolve, reject, language });
          });

          const recordNo = 0;
          const record = records?.[recordNo];

          const text = decodeNdefRecord({ dispatch, record, language });
          dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'mnemonic'], value: text });
          dispatch({ type: 'setNotification', key: 'notification', value: words.readingDone[language] });
        }}
      >
        <div>
          { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </button>
    </>;

  // ネイティブアプリで NFC を読み込む（キーカード形式）
  const readKeyCardNfcWithNativeAppButton =
    <NativeAppReadButton
      nfcrwScan={nfcrwScan}
      intent='keycard'
      label={words.readKeyCardNfcMnemonicWithNativeApp[language]}
    />;

  // ネイティブアプリで NFC を読み込む（プレーンテキスト）
  const readNfcPlainTextWithNativeAppButton =
    <NativeAppReadButton
      nfcrwScan={nfcrwScan}
      intent='plain'
      label={words.readNfcPlainTextMnemonicWithNativeApp[language]}
    />;

  const qrButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.readKeyCardBcMnemonic[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          let encryptedMnemonic;

          try {
            encryptedMnemonic = await new Promise( (resolve, reject) => {
              const popup = {
                type: 'qrCodeReaderPopup',
                body: {
                  resolve,
                  reject,
                },
              };

              dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
            });
          }
          catch {
            // 読み取りのポップアップを閉じたとき（popupClosed）や、カメラが使えないとき（QrCodeReader が通知済み）は、ここで終わる
            return;
          }

          const mnemonic = await decryptByKeyCardStyle({ pass, dispatch, encrypted: encryptedMnemonic, language });
          dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'mnemonic'], value: mnemonic });
        }}
      >
        <div>
          { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconQr} alt='' />
        </div>
      </button>
    </>;

  const qrPlainButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.read2dBarcodePlainTextMnemonic[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          let data;

          try {
            data = await new Promise( (resolve, reject) => {
              const popup = {
                type: 'qrCodeReaderPopup',
                body: {
                  resolve,
                  reject,
                },
              };

              dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
            });
          }
          catch {
            // 読み取りのポップアップを閉じたとき（popupClosed）や、カメラが使えないとき（QrCodeReader が通知済み）は、ここで終わる
            return;
          }

          dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'mnemonic'], value: data });
        }}
      >
        <div>
          { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconQr} alt='' />
        </div>
      </button>
    </>;

  const mnemonicInputButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.inputMnemonicAction[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ () => {
          const popup = {
            type: 'mnemonicInputPopup',
            body: {
              stateKeys: ['configure', 'mnemonic']
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <div>
          { words.input[language] }
        </div>
        <div>
          <img className='size2x2' src={iconEdit} alt='' />
        </div>
      </button>
    </>;

  const setMnemonicButton =
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
      onClick={ async () => {
        // dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'mnemonic'], value: configure.mnemonic });
        dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'wif'], value: '' });
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
      }}
    >
      { words.setMnemonic[language] }
    </button>;

  for (const wallet of walletsAvailable({ hasCamera })) {
    if (wallet === 'nfc') {
      readButtons.push(nfcButton, nfcPlainButton);
    }
    else if (wallet === 'nfcNative') {
      readButtons.push(readKeyCardNfcWithNativeAppButton, readNfcPlainTextWithNativeAppButton);
    }
    else if (wallet === 'qr') {
      readButtons.push(qrButton, qrPlainButton);
    }
  }

  readButtons.push(mnemonicInputButton);


  return (
    <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
        <div>
          { words.importMnemonic[language] }
        </div>
        <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
          onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'mnemonic'], value: null }) }
        >
          {words.clear[language]}
        </button>
      </div>
      <div className='widthMax colorRed marginTop1 '>
        { words.pleaseBeCarefulOfYourSurroundingsSoThatOthersCannotSee[language] }
      </div>
      { readButtons }
      <div className='flexColumn alignItemsFlexStart width90PC borderKOM marginTop1 padding0p5'>
        { configure.mnemonic }
      </div>
      { setMnemonicButton }
    </div>
  );
}

// READ WIF FOR REGISTRATION POPUP ; type: 'readWifForRegistrationPopup'
function ReadWifForRegistrationPopup(props) {
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  const configure = useGlobalStateSelector( ({ state }) => state.configure );
  const hasCamera = useGlobalStateSelector( ({ state }) => state.device?.hasCamera );
  const language = useGlobalStateSelector( ({ state }) => state.language );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const nativeAppAvailable = walletsAvailable({ hasCamera }).includes('nfcNative');

  // iPhone アプリで読み込む（プレーンテキストの 1 件目）
  const nfcrwScan = useNfcrwScan({
    enabled: nativeAppAvailable,
    language,
    // records は Web NFC の形（Web NFC の読み込みボタンと同じ読み方をする）
    onRecords: async ({ records }) => {
      const recordNo = 0;
      const record = records?.[recordNo];

      const text = decodeNdefRecord({ dispatch, record, language });
      dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'wif'], value: text });
      dispatch({ type: 'setNotification', key: 'notification', value: words.readingDone[language] });
    },
    onFailure: () => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToReadNfc[language] });
    },
  });

  let readButtons = [];

  const nfcPlainButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.readNfcPlainTextWif[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithNfcTag[language] });
          const records = await new Promise( (resolve, reject) => {
            readNfc({ dispatch, resolve, reject, language });
          });

          const recordNo = 0;
          const record = records?.[recordNo];

          const text = decodeNdefRecord({ dispatch, record, language });
          dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'wif'], value: text });
          dispatch({ type: 'setNotification', key: 'notification', value: words.readingDone[language] });
        }}
      >
        <div>
          { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </button>
    </>;

  // ネイティブアプリで NFC を読み込む（プレーンテキスト）
  const readNfcPlainTextWithNativeAppButton =
    <NativeAppReadButton
      nfcrwScan={nfcrwScan}
      intent='plain'
      label={words.readNfcPlainTextWifWithNativeApp[language]}
    />;

  const qrPlainButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.read2dBarcodePlainTextWif[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          let data;

          try {
            data = await new Promise( (resolve, reject) => {
              const popup = {
                type: 'qrCodeReaderPopup',
                body: {
                  resolve,
                  reject,
                },
              };

              dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
            });
          }
          catch {
            // 読み取りのポップアップを閉じたとき（popupClosed）や、カメラが使えないとき（QrCodeReader が通知済み）は、ここで終わる
            return;
          }

          dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'wif'], value: data });
        }}
      >
        <div>
          { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconQr} alt='' />
        </div>
      </button>
    </>;

  const wifInputButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.inputWifAction[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ () => {
          const popup = {
            type: 'wifInputPopup',
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <div>
          { words.input[language] }
        </div>
        <div>
          <img className='size2x2' src={iconEdit} alt='' />
        </div>
      </button>
    </>;

  const setWifButton =
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
      onClick={ () => {
        dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'mnemonic'], value: '' });
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
      }}
    >
      { words.setWif[language] }
    </button>;

  for (const wallet of walletsAvailable({ hasCamera })) {
    if (wallet === 'nfc') {
      readButtons.push(nfcPlainButton);
    }
    else if (wallet === 'nfcNative') {
      readButtons.push(readNfcPlainTextWithNativeAppButton);
    }
    else if (wallet === 'qr') {
      readButtons.push(qrPlainButton);
    }
  }

  readButtons.push(wifInputButton);


  return (
    <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
        <div>
          { words.importWif[language] }
        </div>
        <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
          onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'wif'], value: '' }) }
        >
          { words.clear[language] }
        </button>
      </div>
      <div className='widthMax colorRed marginTop1 '>
        { words.pleaseBeCarefulOfYourSurroundingsSoThatOthersCannotSee[language] }
      </div>
      { readButtons }
      <div className='flexColumn alignItemsFlexStart width90PC borderKOM breakAll marginTop1 padding0p5'>
        { configure.wif }
      </div>
      { setWifButton }
    </div>
  );
}

/*
// ユーザー登録ボタン
function UserRegistrationButton(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const cookies = useGlobalStateSelector( ({ cookies }) => cookies );
  const setCookie = useGlobalStateSelector( ({ setCookie }) => setCookie );
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined ? popupLayer + 1 : 0;

  return (
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      onClick={ async () => {
          const result = await handleClickSetup(state, dispatch, cookies, setCookie);

          if (result?.message === 'nfcRequired') {
            const callback = (keyPairs) => {
              handleClickSetup(state, dispatch, cookies, setCookie, keyPairs);
              keepKeyPairsInMemory(state, dispatch, keyPairs);
            };

            handleClickNfc(state, dispatch, callback);
          }
          else if (result?.message === 'bcRequired') {
            const callback = (keyPairs) => {
              handleClickSetup(state, dispatch, cookies, setCookie, keyPairs);
              keepKeyPairsInMemory(state, dispatch, keyPairs);
            };

            handleClickScanQr(state, dispatch, callback, { popupLayer: popupLayerNext });
          }
      }}
    >
      <div>
        {words.signByMainAddressToRegister[state.language]}
      </div>
      { SignIcon() }
    </button>
  );
}
*/

function UserRegistrationButton(props) {
  const clientParameters = useGlobalStateSelector( ({ state }) => state.config.clientParameters );
  const keyPairsInPoolAll = useGlobalStateSelector( ({ state }) => state.keyPairs );
  const assetInfos = useGlobalStateSelector( ({ state }) => state.assetInfo );
  const monacards = useGlobalStateSelector( ({ state }) => state.monacard );
  const language = useGlobalStateSelector( ({ state }) => state.language || 'english' );
  const paths = useGlobalStateSelector( ({ state }) => state.configKB.clientParameters.paths );
  const walletType = useGlobalStateSelector( ({ state }) => state.walletType );
  const configure = useGlobalStateSelector( ({ state }) => state.configure );
  const login = useGlobalStateSelector( ({ state }) => state.login );
  const session = useGlobalStateSelector( ({ state }) => state.session );
  const marginOfSessionTime = useGlobalStateSelector( ({ state }) => state.marginOfSessionTime );
  const usersGeneralIndex = useGlobalStateSelector( ({ state }) => state.usersGeneralIndex );
  const device = useGlobalStateSelector( ({ state }) => state.device );
  const passkey = useGlobalStateSelector( ({ state }) => state.passkey );
  const subAddresses = useGlobalStateSelector( ({ state }) => state.subAddresses );
  const network = useGlobalStateSelector( ({ state }) => state.networkMona );
  const active = useGlobalStateSelector( ({ state }) => state.active );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const cookies = useGlobalStateSelector( ({ cookies }) => cookies );
  const setCookie = useGlobalStateSelector( ({ setCookie }) => setCookie );
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  const pass = clientParameters.specialMessage;

  // iPhone アプリでキーカードを読み、利用登録してログインする（登録ボタンはアプリ起動用の Universal Link になる）
  const nfcrwScan = useNfcrwScan({
    enabled: walletType === 'nfcNative',
    language,
    onRecords: async ({ records }) => {
      try {
        const { mnemonic, keyPairs, addressMain } = await getSecretsFromKeyCardRecords({ dispatch, pass, records, language, network });

        const setupResponse = await handleClickSetup({
          dispatch,
          cookies,
          setCookie,
          keyPairs,
          keyPairsInPoolAll,
          session,
          assetInfos,
          monacards,
          configure,
          walletType,
          network,
          clientParameters,
          marginOfSessionTime,
          language,
          active,
        });

        const sessionToOverride = {
          [addressMain]: {
            sessionId: setupResponse.body.sessionId[addressMain],
            expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
          },
        };

        handleClickLogin({
          dispatch,
          popupLayer,
          keyPairs,
          keyPairsInPoolAll,
          sessionToOverride,
          login,
          walletType,
          session,
          marginOfSessionTime,
          assetInfos,
          monacards,
          network,
          usersGeneralIndex,
          clientParameters,
          language,
        })
        .then( response => {
          dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: response.activeAddress });
        });

        const mnemonicRecords = [{ mnemonic, address: addressMain }];
        keepKeyPairsAndSubAddressesInMemory({ dispatch, mnemonicRecords, paths, periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs, language, network });
      }
      catch {
        return;
      }
    },
    onFailure: () => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToReadNfc[language] });
    },
  });

  let registrationButton;
  let mnemonicImportButtonColor = '';
  let wifImportButtonColor = '';

  if (typeof configure.mnemonic === 'string' && configure.mnemonic !== '') {
    mnemonicImportButtonColor = ' backgroundColorPinkPale';
  }

  if (typeof configure.wif === 'string' && configure.wif !== '') {
    wifImportButtonColor = ' backgroundColorPinkPale';
  }

  const webauthnRegistrationButton =
  <>
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      disabled={ passkey.busy }
      onClick={ async () => {
        try {
          dispatch({ type: 'setStateMultiLayers', keys: ['passkey', 'busy'], value: true });

          const wifIsSet = typeof configure.wif === 'string' && configure.wif !== '';
          let registrationResult;

          if (wifIsSet) {
            registrationResult = await handleClickRegisterInitialFromWif({
              dispatch,
              wif: configure.wif,
              configure,
              network,
              language,
            });
          }
          else {
            registrationResult = await handleClickRegisterInitial({
              dispatch,
              mnemonic: configure.mnemonic,
              configure,
              network,
              language,
            });
          }

          const { mnemonic, keyPairs, address: addressMain } = registrationResult;

          const setupResponse = await handleClickSetup({
            dispatch,
            cookies,
            setCookie,
            keyPairs,
            keyPairsInPoolAll,
            session,
            assetInfos,
            monacards,
            configure,
            walletType,
            network,
            clientParameters,
            marginOfSessionTime,
            language,
            active,
          });

          const sessionToOverride = {
            [addressMain]: {
              sessionId: setupResponse.body.sessionId[addressMain],
              expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
            },
          };

          handleClickLogin({
            dispatch,
            popupLayer,
            keyPairs,
            keyPairsInPoolAll,
            sessionToOverride,
            login,
            walletType,
            session,
            marginOfSessionTime,
            assetInfos,
            monacards,
            network,
            usersGeneralIndex,
            clientParameters,
            language,
          })
          .then( response => {
            if (wifIsSet) {
              // WIFは階層鍵ではないため親アドレスを持たない
              dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: null });
            }
            else {
              dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: response.activeAddress });
            }
          });

          if (wifIsSet) {
            // WIFは単一鍵のため、ニーモニック由来のサブアドレス展開は行わない
            keepKeyPairsInMemory({
              dispatch,
              keyPairs,
              periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs,
              language,
              network,
            });

            dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'wif'], value: '' });
          }
          else {
            const popup = { type: 'confirmMnemonicPopup', body: { mnemonic } };
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });

            const mnemonicRecords = [{ mnemonic, address: addressMain }];
            keepKeyPairsAndSubAddressesInMemory({ dispatch, mnemonicRecords, paths, periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs, language, network });
          }
        }
        finally {
          dispatch({ type: 'setStateMultiLayers', keys: ['passkey', 'busy'], value: false });
        }
      }}
    >
      <div>
        {words.initialRegistration[language]}
      </div>
      <SignIcon />
    </button>
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      disabled={ passkey.busy }
      onClick={ async () => {
        try {
          dispatch({ type: 'setStateMultiLayers', keys: ['passkey', 'busy'], value: true });

          const wifIsSet = typeof configure.wif === 'string' && configure.wif !== '';
          let registrationResult;

          if (wifIsSet) {
            registrationResult = await handleClickRegisterAdditionalFromWif({
              dispatch,
              wif: configure.wif,
              configure,
              network,
              language,
            });
          }
          else {
            registrationResult = await handleClickRegisterAdditional({
              dispatch,
              mnemonic: configure.mnemonic,
              configure,
              network,
              language,
            });
          }

          const { mnemonic, keyPairs, address: addressMain } = registrationResult;

          const setupResponse = await handleClickSetup({
            dispatch,
            cookies,
            setCookie,
            keyPairs,
            keyPairsInPoolAll,
            session,
            assetInfos,
            monacards,
            configure,
            walletType,
            network,
            clientParameters,
            marginOfSessionTime,
            language,
            active,
          });

          const sessionToOverride = {
            [addressMain]: {
              sessionId: setupResponse.body.sessionId[addressMain],
              expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
            },
          };

          handleClickLogin({
            dispatch,
            popupLayer,
            keyPairs,
            keyPairsInPoolAll,
            sessionToOverride,
            login,
            walletType,
            session,
            marginOfSessionTime,
            assetInfos,
            monacards,
            network,
            usersGeneralIndex,
            clientParameters,
            language,
          })
          .then( response => {
            if (wifIsSet) {
              // WIFは階層鍵ではないため親アドレスを持たない
              dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: null });
            }
            else {
              dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: response.activeAddress });
            }
          });

          if (wifIsSet) {
            // WIFは単一鍵のため、ニーモニック由来のサブアドレス展開は行わない
            keepKeyPairsInMemory({
              dispatch,
              keyPairs,
              periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs,
              language,
              network,
            });

            dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'wif'], value: '' });
          }
          else {
            const popup = { type: 'confirmMnemonicPopup', body: { mnemonic } };
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });

            const mnemonicRecords = [{ mnemonic, address: addressMain }];
            keepKeyPairsAndSubAddressesInMemory({ dispatch, mnemonicRecords, paths, periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs, language, network });
          }
        }
        finally {
          dispatch({ type: 'setStateMultiLayers', keys: ['passkey', 'busy'], value: false });
        }
      }}
    >
      <div>
        {words.additionalRegistration[language]}
      </div>
      <SignIcon />
    </button>
    <button className={'buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' + mnemonicImportButtonColor} tabindex='0'
      onClick={ () => {
        const popup = {
          type: 'readMnemonicForRegistrationPopup',
        }

        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
      }}
    >
      { words.importMnemonic[language] }
    </button>
    <button className={'buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' + wifImportButtonColor} tabindex='0'
      onClick={ () => {
        const popup = {
          type: 'readWifForRegistrationPopup',
        }

        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
      }}
    >
      { words.importWif[language] }
    </button>
  </>;

  if (walletType === 'keybox') {
    registrationButton =
    <div className='flexColumn alignItemsCenter'>
      { webauthnRegistrationButton }
    </div>;
  }
  else if (walletType === 'nfc') {
    registrationButton =
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      onClick={ async () => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[language] });
        const { mnemonic, keyPairs, addressMain } = await getSecretsFromNfc({ dispatch, pass, language, network });

        const setupResponse = await handleClickSetup({
          dispatch,
          cookies,
          setCookie,
          keyPairs,
          keyPairsInPoolAll,
          session,
          assetInfos,
          monacards,
          configure,
          walletType,
          network,
          clientParameters,
          marginOfSessionTime,
          language,
          active,
        });

        const sessionToOverride = {
          [addressMain]: {
            sessionId: setupResponse.body.sessionId[addressMain],
            expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
          },
        };

        handleClickLogin({
          dispatch,
          popupLayer,
          keyPairs,
          keyPairsInPoolAll,
          sessionToOverride,
          login,
          walletType,
          session,
          marginOfSessionTime,
          assetInfos,
          monacards,
          network,
          usersGeneralIndex,
          clientParameters,
          language,
        })
        .then( response => {
          dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: response.activeAddress });
        });

        const mnemonicRecords = [{ mnemonic, address: addressMain }];
        keepKeyPairsAndSubAddressesInMemory({ dispatch, mnemonicRecords, paths, periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs, language, network });
      }}
    >
      <div>
        {words.serviceAccessRegistration[language]}
      </div>
      <SignIcon />
    </button>;
  }
  else if (walletType === 'nfcNative') {
    registrationButton =
    <NativeAppReadButton
      nfcrwScan={nfcrwScan}
      intent='keycard'
      marginTop={false}
      // 名前や同意が欠けたままアプリへ出ない（戻ってから言われないように、先に確かめる）
      canStart={ () => checkRequiredItemsForSetup({ dispatch, configure, language }) }
      face={
        <>
          <div>
            {words.serviceAccessRegistration[language]}
          </div>
          <SignIcon />
        </>
      }
    />;
  }
  else if (walletType === 'qr') {
    registrationButton =
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      onClick={ async () => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[language] });
        let secrets;

        try {
          secrets = await getSecretsFromQr({ dispatch, pass, popupLayer, language, network });
        }
        catch {
          // 読み取りのポップアップを閉じたとき（popupClosed）や、読み取り・復号できなかったとき（通知済み）は、ここで終わる
          return;
        }

        const { mnemonic, keyPairs, addressMain } = secrets;

        const setupResponse = await handleClickSetup({
          dispatch,
          cookies,
          setCookie,
          keyPairs,
          keyPairsInPoolAll,
          session,
          assetInfos,
          monacards,
          configure,
          walletType,
          network,
          clientParameters,
          marginOfSessionTime,
          language,
          active,
        });

        const sessionToOverride = {
          [addressMain]: {
            sessionId: setupResponse.body.sessionId[addressMain],
            expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
          },
        };

        handleClickLogin({
          dispatch,
          popupLayer,
          keyPairs,
          keyPairsInPoolAll,
          sessionToOverride,
          login,
          walletType,
          session,
          marginOfSessionTime,
          assetInfos,
          monacards,
          network,
          usersGeneralIndex,
          clientParameters,
          language,
        })
        .then( response => {
          dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: response.activeAddress });
        });

        const mnemonicRecords = [{ mnemonic, address: addressMain }];
        keepKeyPairsAndSubAddressesInMemory({ dispatch, mnemonicRecords, paths, periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs, language, network });
      }}
    >
      <div>
        {words.serviceAccessRegistration[language]}
      </div>
      <SignIcon />
    </button>;
  }
  else if (walletType === 'keypool') {
    registrationButton =
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      onClick={ async () => {
        const addressMain = configure.addressMain;
        if (addressMain === undefined || addressMain === null || addressMain === '') {
          dispatch({ type: 'setNotification', key: 'notification', value: words.selectAnAddressFromTheKeypool[language] });
          throw new Error('addressMain is not selected');
        }

        const setupResponse = await handleClickSetup({
          dispatch,
          cookies,
          setCookie,
          keyPairs: undefined,
          keyPairsInPoolAll,
          session,
          assetInfos,
          monacards,
          configure,
          walletType,
          network,
          clientParameters,
          marginOfSessionTime,
          language,
          active,
        });

        const sessionToOverride = {
          [addressMain]: {
            sessionId: setupResponse.body.sessionId[addressMain],
            expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
          },
        };

        handleClickLogin({
          dispatch,
          popupLayer,
          keyPairs: null,
          keyPairsInPoolAll,
          sessionToOverride,
          activeAddressCandidate: addressMain,
          login,
          walletType,
          session,
          marginOfSessionTime,
          assetInfos,
          monacards,
          network,
          usersGeneralIndex,
          clientParameters,
          language,
        })
        .then( (loginResponse) => {
          const parentAddress = getParentAddressFromSubAddress({ subAddresses, subAddress: loginResponse?.activeAddress });
          dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: parentAddress });
        });
      }}
    >
      <div>
        {words.serviceAccessRegistration[language]}
      </div>
      <SignIcon />
    </button>;
  }
  else if (walletType === 'mpurse') {
    registrationButton =
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      onClick={ async () => {
        const setupResponse = await handleClickSetup({
          dispatch,
          cookies,
          setCookie,
          keyPairs: undefined,
          keyPairsInPoolAll,
          session,
          assetInfos,
          monacards,
          configure,
          walletType,
          network,
          clientParameters,
          marginOfSessionTime,
          language,
          active,
        });

        const addressMain = Object.keys(setupResponse.body.sessionId)[0];
        const sessionToOverride = {
          [addressMain]: {
            sessionId: setupResponse.body.sessionId[addressMain],
            expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
          },
        };

        handleClickLogin({
          dispatch,
          popupLayer,
          keyPairs: null,
          keyPairsInPoolAll,
          sessionToOverride,
          login,
          walletType,
          session,
          marginOfSessionTime,
          assetInfos,
          monacards,
          network,
          usersGeneralIndex,
          clientParameters,
          language,
        })
        .then( response => {
          // keyPair を渡してないので、ログイン時に、他のアドレスに active を上書きされる可能性があるので、さらに上書く。
          dispatch({ type: 'setStateMultiLayers', keys: ['active', 'addressMain'], value: addressMain });
        });
      }}
    >
      <div>
        {words.serviceAccessRegistration[language]}
      </div>
      <SignIcon />
    </button>;
  }
  else {
    registrationButton =
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      onClick={ async () => {
        if (walletType === undefined || walletType === null) {
          const walletType = walletsAvailable({ hasCamera: device?.hasCamera })[0];
          dispatch({ type: 'setState', key: 'walletType', value: walletType });
        }

        const result = await handleClickSetup({
          dispatch,
          cookies,
          setCookie,
          keyPairs: undefined,
          keyPairsInPoolAll,
          session,
          assetInfos,
          monacards,
          configure,
          walletType,
          network,
          clientParameters,
          marginOfSessionTime,
          language,
          active,
        });

        if (result?.message === 'nfcRequired') {
          const { mnemonic, keyPairs, addressMain } = await getSecretsFromNfc({ dispatch, pass, language, network });

          const setupResponse = await handleClickSetup({
            dispatch,
            cookies,
            setCookie,
            keyPairs,
            keyPairsInPoolAll,
            session,
            assetInfos,
            monacards,
            configure,
            walletType,
            network,
            clientParameters,
            marginOfSessionTime,
            language,
            active,
          });

          const sessionToOverride = {
            [addressMain]: {
              sessionId: setupResponse.body.sessionId[addressMain],
              expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
            },
          };

          handleClickLogin({
            dispatch,
            popupLayer,
            keyPairs,
            keyPairsInPoolAll,
            sessionToOverride,
            login,
            walletType,
            session,
            marginOfSessionTime,
            assetInfos,
            monacards,
            network,
            usersGeneralIndex,
            clientParameters,
            language,
          })
          .then( response => {
            dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: response.activeAddress });
          });

          const mnemonicRecords = [{ mnemonic, address: addressMain }];
          keepKeyPairsAndSubAddressesInMemory({ dispatch, mnemonicRecords, paths, periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs, language, network });
        }
        else if (result?.message === 'bcRequired') {
          let secrets;

          try {
            secrets = await getSecretsFromQr({ dispatch, pass, popupLayer, language, network });
          }
          catch {
            // 読み取りのポップアップを閉じたとき（popupClosed）や、読み取り・復号できなかったとき（通知済み）は、ここで終わる
            return;
          }

          const { mnemonic, keyPairs, addressMain } = secrets;

          const setupResponse = await handleClickSetup({
            dispatch,
            cookies,
            setCookie,
            keyPairs,
            keyPairsInPoolAll,
            session,
            assetInfos,
            monacards,
            configure,
            walletType,
            network,
            clientParameters,
            marginOfSessionTime,
            language,
            active,
          });

          const sessionToOverride = {
            [addressMain]: {
              sessionId: setupResponse.body.sessionId[addressMain],
              expirationOfSession: setupResponse.body.expirationOfSession[addressMain],
            },
          };

          handleClickLogin({
            dispatch,
            popupLayer,
            keyPairs,
            keyPairsInPoolAll,
            sessionToOverride,
            login,
            walletType,
            session,
            marginOfSessionTime,
            assetInfos,
            monacards,
            network,
            usersGeneralIndex,
            clientParameters,
            language,
          })
          .then( response => {
            dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: response.activeAddress });
          });

          const mnemonicRecords = [{ mnemonic, address: addressMain }];
          keepKeyPairsAndSubAddressesInMemory({ dispatch, mnemonicRecords, paths, periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs, language, network });
        }
      }}
    >
      <div>
        {words.serviceAccessRegistration[language]}
      </div>
      <SignIcon />
    </button>;
  }

  return registrationButton;
}

// マイホームを作るかどうか選択
function SelectMakeMyHomeOrNot() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  return (
    <div className='flexRow justifyContentCenter marginSide1'>
      <button className={'box3 focusEffect01 riseOut2 ' + (state.configure.homed ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
        onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['configure', 'homed'], value: true});
        }}>
        {words.haveMyHome[state.language]}
      </button>
      <button className={'box3 focusEffect01 riseOut2 ' + (!state.configure.homed ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
        onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['configure', 'homed'], value: false});
        }}>
        {words.notHaveMyHome[state.language]}
      </button>
    </div>
  );
}

// eslint-disable-next-line no-unused-vars
function _TermsAndConditions() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  // TAC文言

  let tacWord;

  if (state.configure.acceptedVersionOfTheTermsAndConditions === state.config.clientParameters.versionOfTheTermsAndConditions &&
      state.configure.acceptedVersionOfPrivacyPolicy === state.config.clientParameters.versionOfPrivacyPolicy) {
    tacWord = words.theTermsAndConditionsAndPrivacypolicyHaveBeenAccepted[state.language];
  }
  else {
    tacWord = words.termsAndConditionsAndPrivacypolicy[state.language];
  }

  // 利用規約ボタン

  const tacButton =
  <button
    className={
      'borderNone backgroundColorWhite heightMin3 textLeft focusEffect01 cursor borderRadius2 riseOut2 marginTopBottom0p5' +
      (state.configure.readTheTermsAndConditions ? '' : 'colorRed')
    }
    tabindex='0'
    onClick={ () => {
      window.open('https://' + process.env.REACT_APP_MONACOTTO_TERMS_AND_CONDITIONS);
      dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'readTheTermsAndConditions'], value: true });
      dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'readPrivacyPolicy'], value: true });
    }}
  >
    { tacWord }
  </button>;

  // 利用規約同意チェックボックス

  let check;
  let checkboxColor;

  if (
    state.configure.acceptedVersionOfTheTermsAndConditions === state.config.clientParameters.versionOfTheTermsAndConditions &&
    state.configure.acceptedVersionOfPrivacyPolicy === state.config.clientParameters.versionOfPrivacyPolicy
  ) {
    check = <img className='size1x1' src={iconCheck} alt='check' />;
    checkboxColor = 'backgroundColorPinkPale';
  }
  else {
    checkboxColor = 'backgroundColorTransparent';
  }

  const tacCheckbox =
  <button
    className={ 'width1p2 height1p2 borderMonacottoNoRadius padding0 marginSide1 ' + checkboxColor }
    onClick={ () => {
      if (
        state.configure.acceptedVersionOfTheTermsAndConditions !== state.config.clientParameters.versionOfTheTermsAndConditions ||
        state.configure.acceptedVersionOfPrivacyPolicy !== state.config.clientParameters.versionOfPrivacyPolicy
      ) {
        dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'acceptedVersionOfTheTermsAndConditions'], value: state.config.clientParameters.versionOfTheTermsAndConditions });
        dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'acceptedVersionOfPrivacyPolicy'], value: state.config.clientParameters.versionOfPrivacyPolicy });
      }
      else {
        dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'acceptedVersionOfTheTermsAndConditions'], value: null });
        dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'acceptedVersionOfPrivacyPolicy'], value: null });
      }
    }}  
  >
    { check }
  </button>;


  return (
    <div className='flexRow justifyContentFlexStart alignItemsCenter '>
      { tacCheckbox }
      { tacButton }
    </div>
  );
}

function TermsAndConditions(props) {
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  const state = useGlobalStateSelector( ({ state }) => state );
  const configure = useGlobalStateSelector( ({ state }) => state.configure );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  // TAC文言

  let tacWord;

  if (
    configure.acceptedVersionOfTheTermsAndConditions === state.config.clientParameters.versionOfTheTermsAndConditions &&
    configure.acceptedVersionOfPrivacyPolicy === state.config.clientParameters.versionOfPrivacyPolicy
  ) {
    tacWord = words.theTermsAndConditionsAndPrivacypolicyHaveBeenAccepted[state.language];
  }
  else {
    tacWord = words.termsAndConditionsAndPrivacypolicy[state.language];
  }

  // 利用規約ボタン

  const tacButton =
  <button
    className={
      'borderNone backgroundColorWhite heightMin3 textLeft focusEffect01 cursor borderRadius2 riseOut2 marginTopBottom0p5' +
      (configure.readTheTermsAndConditions ? '' : 'colorRed')
    }
    tabindex='0'
    onClick={ () => {
      const popup = {
        type: 'termsAndConditionsPopup',
        body: { target: 'exhibitor' },
      };

      dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
      dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'readTheTermsAndConditions'], value: true });
      dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'readPrivacyPolicy'], value: true });
    }}
  >
    { tacWord }
  </button>;

  // 利用規約同意チェックボックス

  let check;
  let checkboxColor;

  if (
    state.configure.acceptedVersionOfTheTermsAndConditions === state.config.clientParameters.versionOfTheTermsAndConditions &&
    state.configure.acceptedVersionOfPrivacyPolicy === state.config.clientParameters.versionOfPrivacyPolicy
  ) {
    check = <img className='size1x1' src={iconCheck} alt='check' />;
    checkboxColor = 'backgroundColorPinkPale';
  }
  else {
    checkboxColor = 'backgroundColorTransparent';
  }

  const tacCheckbox =
  <button
    className={ 'width1p2 height1p2 borderMonacottoNoRadius padding0 marginSide1 ' + checkboxColor }
    onClick={ () => {
      if (
        state.configure.acceptedVersionOfTheTermsAndConditions !== state.config.clientParameters.versionOfTheTermsAndConditions ||
        state.configure.acceptedVersionOfPrivacyPolicy !== state.config.clientParameters.versionOfPrivacyPolicy
      ) {
        dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'acceptedVersionOfTheTermsAndConditions'], value: state.config.clientParameters.versionOfTheTermsAndConditions });
        dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'acceptedVersionOfPrivacyPolicy'], value: state.config.clientParameters.versionOfPrivacyPolicy });
      }
      else {
        dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'acceptedVersionOfTheTermsAndConditions'], value: null });
        dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'acceptedVersionOfPrivacyPolicy'], value: null });
      }
    }}  
  >
    { check }
  </button>;


  return (
    <div className='flexRow justifyContentFlexStart alignItemsCenter '>
      { tacCheckbox }
      { tacButton }
    </div>
  );
}

export {
  UserRegistrationPopup,
  UserRegistration,
  ReadMnemonicForRegistrationPopup,
  ReadWifForRegistrationPopup,
  UserRegistrationButton,
  SelectMakeMyHomeOrNot,
  TermsAndConditions,
  TermsAndConditionsPopup,
};
